import { Box, Button, Grid, LinearProgressProps, Typography } from '@mui/material';
import { ProgressData } from '../../../../Modules/CentralDataManagement/Imports/IndividualImport/IndividualImport';
import { MDAlert } from '../MDAlert';
import { MDBox } from '../MDBox';
import { MDProgress } from '../MDProgress';
import { MDTypography } from '../MDTypography';


export function ImportProgressBarWithErrorList(props: LinearProgressProps & { value: number } & { progressData: ProgressData }) {

    const downloadErrorLog = () => {
        const link = document.createElement("a");
        link.download = `errorLog.csv`;
        link.href = props.progressData.errorLogUrl!;
        link.click();
    };

    return (
        <>
            {(props.progressData?.log == null || props.progressData?.isSuccess == true) && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <Box sx={{ width: '100%', mr: 1 }}>
                        <MDProgress variant="determinate" {...props} />
                    </Box>
                    <Box sx={{ minWidth: 40 }}>
                        <Typography variant="body2" color="text.secondary">{`${Math.round(props.value)}%`}</Typography>
                    </Box>
                </Box>
            )}
            <MDBox width={"100%"}>
                {props.progressData?.numberOfRowsCorrect > 0 && (
                    <MDAlert color="success" mt={1} sx={{ width: "100%" }}>
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                <MDBox>
                                    <MDTypography component='span' fontWeight='bold' fontSize="1.35rem" color="white">
                                        Number of correct rows: {props.progressData?.numberOfRowsCorrect}
                                    </MDTypography>
                                </MDBox>
                            </Grid>
                        </Grid>
                    </MDAlert>
                )}
                {props.progressData?.log?.length > 0 && (
                    <MDAlert color="error" mt={1} sx={{ width: "100%", overflowY: "auto" }}>
                        <Grid container>
                            <Grid item xs={12} lg={12}>
                                {props.progressData?.numberOfRowsFailed > 0 && (
                                    <MDBox mb={2}>
                                        <MDTypography component='span' fontWeight='bold' fontSize="1.35rem" color="white">
                                            Number of failed rows: {props.progressData?.numberOfRowsFailed}
                                        </MDTypography>
                                    </MDBox>
                                )}
                                {(props.progressData?.log?.length > 0 && props.progressData?.errorLogUrl != null) && (
                                    <MDBox mb={2}>
                                        <Button
                                            variant='contained'
                                            onClick={() => {
                                                downloadErrorLog()
                                            }}
                                        >
                                            Download Error Log
                                        </Button>
                                    </MDBox>
                                )}
                                {props.progressData?.log?.map((error, index) => (
                                    <MDTypography key={index} component='p' variant='body' fontWeight='regular' color="white" mb={1} width={"100%"}>
                                        {error}
                                    </MDTypography>
                                ))}
                            </Grid>
                        </Grid>
                    </MDAlert>
                )}
            </MDBox>
        </>
    );
}